var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLinkicon = function SvgExternalLinkicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.5 6.43c0-1.2.98-2.18 2.19-2.18H7c.28 0 .5.22.5.5v.87a.5.5 0 0 1-.5.5H4.69a.31.31 0 0 0-.31.31v10.63c0 .17.14.31.3.31h10.63c.18 0 .32-.14.32-.31v-2.31c0-.28.22-.5.5-.5H17c.28 0 .5.22.5.5v2.3c0 1.22-.98 2.2-2.19 2.2H4.7c-1.21 0-2.19-.98-2.19-2.2V6.44Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.79 3.25c.35 0 .63.28.63.63v6.75c0 .35-.28.63-.63.63h-.63a.62.62 0 0 1-.62-.63V6.45l-7.68 7.68a.62.62 0 0 1-.88 0l-.45-.44a.63.63 0 0 1 0-.88l7.68-7.69h-4.18a.62.62 0 0 1-.62-.62v-.63c0-.34.28-.62.62-.62h6.76Z",
    clipRule: "evenodd"
  })));
};
export default SvgExternalLinkicon;